const initState = {
    tabIndex: 0,
    scaleWeight: "0.000"

}
const GlobalReducer = (state = initState, action) => {

    switch (action.type) {
        case "SET_TAB_INDEX":
            return {
                ...state,
                tabIndex: action.index,
            }
        case "SET_SCALE_WEIGHT":
            return {
                ...state,
                scaleWeight: action.scaleWeight,
            }
        default: return state;
    }

}

export default GlobalReducer;